import { render, staticRenderFns } from "./ShippingTiers.vue?vue&type=template&id=c2239550&"
import script from "./ShippingTiers.vue?vue&type=script&lang=js&"
export * from "./ShippingTiers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports